<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Estoque Localização
            <Modal
              :tipoSelecao="'single'"
              @unidade="getEstoqueLocalizacao"
              :loadingValue="loadingValue"
              :dataDisable="true"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :exportName="'Estoque_Localização'"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'estoquelocalizacao'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
    <q-dialog persistent v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            @click="openModal++"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/Modal.vue";
import Flexmonster from "../components/Flexmonster.vue";
import { transformCsvAndSetLink } from "../../../utils/csvHelper.js";
export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      codigo: { type: "string" },
      descricao: { type: "string" },
      quantidade: { type: "number", format: "numberFormat" },
      valor_unitario: { type: "number", format: "numberFormat" },
      total: { type: "number", format: "numberFormat" },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
      {
        name: "numberFormat",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: -1,
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const targetColumns = ["quantidade", "valor_unitario", "total"];

    const filtrosObject = ref(null);
    const showComentarioMovimentacao = ref(false);

    const getEstoqueLocalizacao = async (data, singleValue) => {
      try {
        filtrosObject.value = {
          vendor_id: singleValue.id,
        };
        loadingValue.value = true;
        const response = await store.dispatch("rel/getEstoqueLocalizacao", {
          vendor_id: singleValue.id,
        });

        link.value = await transformCsvAndSetLink(
          response.data.return.url,
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        if (error?.response?.status == undefined) {
          showComentarioMovimentacao.value = !showComentarioMovimentacao.value;
          getRelatorioSecundario();
        }
      }
    };

    const getRelatorioSecundario = async () => {
      loadingValue.value = true;

      const response = await store.dispatch("rel/getEstoqueLocalizacao", {
        vendor_id: filtrosObject.value.vendor_id,
        background: 1,
      });

      link.value = await transformCsvAndSetLink(
        response.data.resultado.dados,
        targetColumns
      );
      updateLink.value++;
      loadingValue.value = false;
      exibir.value = true;
      url.value = response?.request?.responseURL;
    };
    const relatorioLink = route.query.id;
    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = await transformCsvAndSetLink(
          response.data.return.url,
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        relatorioLink != "" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = await transformCsvAndSetLink(
        response.return.url,
        targetColumns
      );

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getEstoqueLocalizacao,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      getRelatorioSalvo,
      filtros,
      showTotals,
      id,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
      filtrosObject,
      showComentarioMovimentacao,
    };
  },
};
</script>
